import React, { Component } from 'react'
import tableComponents from '../../tableComponents'
import { checkTranslation, translate } from '../../../utils/useful'

export default class MatrixInfoCell extends Component {
    state = {
    }


    render() {

        // TO DO: should change the logix of this
        let data = this.props.data[1]?.info ?? {}
        let header = this.props.header

        let Component = tableComponents[header.type]


        if (data == '*undefined' || (data && checkTranslation(data).toLowerCase() == 'undefined')) {
            return (
                <div className='w-100'>
                    <p className='text-small w-100'>{translate("Undefined")}</p>
                </div>
            )
        } else {


            return (

                <>
                    {Component && (
                        <Component header={header} data={data} fullData={this.props.data[1]?.fullData} />
                    )}
                    {/* <div className='flexc br-20 prd-3 pld-2 py-1 ' style={{ color: data['textColor'] ?? '#000', background: columnHeader['backColor'] }}>
                    <p className='font-size-14 ' >{label}</p>
                </div> */}
                </>


            )
        }
    }

}
